import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { RenderGroupRowCellProps } from "../../Group/Content";
import PersonalSettingsSpacesItemCell from "../Cell";

const PersonalSettingsSpacesTableGroupRowCellSpace = memo((props: RenderGroupRowCellProps) => {
  return (
    <PersonalSettingsSpacesItemCell {...props}>
      <TableCellEmpty />
    </PersonalSettingsSpacesItemCell>
  );
});

PersonalSettingsSpacesTableGroupRowCellSpace.displayName =
  "PersonalSettingsSpacesTableGroupRowCellSpace";

export default PersonalSettingsSpacesTableGroupRowCellSpace;
